(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["seo-author-template"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-seo-author-section]';
    const registryKey = '__seoAuthorTemplateController';

    if (window[registryKey]) {
      window[registryKey].initializeWithin(document);
      return;
    }

    const setupBackButton = (root) => {
      const button = root.querySelector('[data-author-back]');
      if (!button) return;

      button.hidden = true;
      delete button.dataset.authorBackUrl;

      try {
        if (!document.referrer) return;

        const referrerUrl = new URL(document.referrer);
        const currentUrl = new URL(window.location.href);
        const referrerWithoutHash = `${referrerUrl.origin}${referrerUrl.pathname}${referrerUrl.search}`;
        const currentWithoutHash = `${currentUrl.origin}${currentUrl.pathname}${currentUrl.search}`;
        const blogArticlePattern = /^\/blogs\/[^/]+\/[^/]+\/?$/;

        if (referrerUrl.origin !== window.location.origin) return;
        if (referrerWithoutHash === currentWithoutHash) return;
        if (!blogArticlePattern.test(referrerUrl.pathname)) return;

        button.dataset.authorBackUrl = referrerUrl.href;
        button.hidden = false;
        button.addEventListener('click', () => {
          if (button.dataset.authorBackUrl) {
            window.location.assign(button.dataset.authorBackUrl);
          }
        });
      } catch (_error) {
        button.hidden = true;
      }
    };

    const setupPagination = (root) => {
      const cards = Array.from(root.querySelectorAll('[data-author-article-card]'));
      const pagination = root.querySelector('[data-author-pagination]');
      const previousButton = root.querySelector('[data-author-page-prev]');
      const nextButton = root.querySelector('[data-author-page-next]');
      const status = root.querySelector('[data-author-page-status]');
      const articles = root.querySelector('[data-author-articles]');
      const articlesHeading = root.querySelector('.seo-author-articles__header h2');
      const parsedPerPage = Number.parseInt(root.dataset.articlesPerPage, 10);
      const perPage = Number.isFinite(parsedPerPage) ? Math.max(parsedPerPage, 9) : 9;
      const totalPages = Math.ceil(cards.length / perPage);

      if (!pagination || !previousButton || !nextButton || !status || totalPages <= 1) {
        if (pagination) pagination.hidden = true;
        return;
      }

      const getRequestedPage = () => {
        const rawPage = new URL(window.location.href).searchParams.get('author_page');
        const page = Number(rawPage);
        return Number.isInteger(page) ? page : 1;
      };

      const pageFromUrl = () => Math.min(Math.max(getRequestedPage(), 1), totalPages);

      const updateUrl = (page, method) => {
        const url = new URL(window.location.href);
        if (page === 1) {
          url.searchParams.delete('author_page');
        } else {
          url.searchParams.set('author_page', String(page));
        }
        window.history[method === 'replace' ? 'replaceState' : 'pushState']({}, '', url);
      };

      const scrollToArticles = () => {
        if (!articles) return;
        const headerOffset = Number.parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
        const top = articles.getBoundingClientRect().top + window.scrollY - headerOffset - 24;
        window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
        articlesHeading?.focus({ preventScroll: true });
      };

      const renderPage = (page, options = {}) => {
        const safePage = Math.min(Math.max(page, 1), totalPages);
        const firstVisibleIndex = (safePage - 1) * perPage;
        const lastVisibleIndex = firstVisibleIndex + perPage;

        cards.forEach((card, index) => {
          card.hidden = index < firstVisibleIndex || index >= lastVisibleIndex;
        });

        previousButton.disabled = safePage === 1;
        nextButton.disabled = safePage === totalPages;
        status.textContent = `Page ${safePage} of ${totalPages}`;
        pagination.hidden = false;
        root.dataset.authorCurrentPage = String(safePage);

        if (options.updateUrl) updateUrl(safePage, options.updateUrl);
        if (options.scroll) scrollToArticles();
      };

      previousButton.addEventListener('click', () => {
        renderPage(Number(root.dataset.authorCurrentPage) - 1, { updateUrl: 'push', scroll: true });
      });
      nextButton.addEventListener('click', () => {
        renderPage(Number(root.dataset.authorCurrentPage) + 1, { updateUrl: 'push', scroll: true });
      });
      window.addEventListener('popstate', () => renderPage(pageFromUrl()));

      const currentUrl = new URL(window.location.href);
      const rawPage = currentUrl.searchParams.get('author_page');
      const initialPage = pageFromUrl();
      const shouldNormalizeUrl = rawPage !== null && (initialPage === 1 || rawPage !== String(initialPage));
      renderPage(initialPage, { updateUrl: shouldNormalizeUrl ? 'replace' : null });
    };

    const initialize = (root) => {
      if (!root || root.dataset.authorTemplateReady === 'true') return;
      root.dataset.authorTemplateReady = 'true';
      setupBackButton(root);
      setupPagination(root);
    };

    const initializeWithin = (scope) => {
      if (scope.matches?.(selector)) initialize(scope);
      scope.querySelectorAll?.(selector).forEach(initialize);
    };

    window[registryKey] = { initializeWithin };

    const initializeDocument = () => initializeWithin(document);
    if (document.readyState !== 'loading') {
      initializeDocument();
    } else {
      document.addEventListener('DOMContentLoaded', initializeDocument, { once: true });
    }

    document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
